import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['fr', 'en', 'es'] as const,
  defaultLocale: 'fr',
  localeDetection: false,
  alternateLinks: false,
  pathnames: {
    '/': '/',
    '/menu': '/menu',
    '/menu/[category]': '/menu/[category]',
    '/commande-a-emporter': {
      fr: '/commande-a-emporter',
      en: '/takeaway',
      es: '/para-llevar',
    },
    '/en-ce-moment': {
      fr: '/en-ce-moment',
      en: '/whats-on',
      es: '/actualidad',
    },
    '/en-ce-moment/[slug]': {
      fr: '/en-ce-moment/[slug]',
      en: '/whats-on/[slug]',
      es: '/actualidad/[slug]',
    },
    '/en-ce-moment/plat-du-jour': {
      fr: '/en-ce-moment/plat-du-jour',
      en: '/whats-on/daily-specials',
      es: '/actualidad/platos-del-dia',
    },
    '/en-ce-moment/plat-du-jour/[slug]': {
      fr: '/en-ce-moment/plat-du-jour/[slug]',
      en: '/whats-on/daily-special/[slug]',
      es: '/actualidad/plato-del-dia/[slug]',
    },
    '/contact': {
      fr: '/contact',
      en: '/contact',
      es: '/contacto',
    },
    '/horaires': {
      fr: '/horaires',
      en: '/hours',
      es: '/horarios',
    },
    '/mentions-legales': {
      fr: '/mentions-legales',
      en: '/legal-notice',
      es: '/aviso-legal',
    },
    '/politique-de-confidentialite': {
      fr: '/politique-de-confidentialite',
      en: '/privacy-policy',
      es: '/politica-de-privacidad',
    },
    '/cgu': {
      fr: '/cgu',
      en: '/terms-of-use',
      es: '/condiciones-de-uso',
    },
    '/cgv': {
      fr: '/cgv',
      en: '/terms-of-sale',
      es: '/condiciones-de-venta',
    },
  },
});

export type Pathnames = keyof typeof routing.pathnames;
export type Locale = (typeof routing.locales)[number];
